export const MOBILE_VIEWPORT_BREAKPOINT = 768;

export const getViewportWidth = viewport => {
  const widthFromViewport = Number(viewport?.width);
  if (Number.isFinite(widthFromViewport) && widthFromViewport > 0) {
    return widthFromViewport;
  }

  if (typeof window !== 'undefined' && Number.isFinite(window.innerWidth) && window.innerWidth > 0) {
    return window.innerWidth;
  }

  // Keep SSR/non-browser fallback as desktop-like to avoid accidental mobile-only rendering.
  return Number.POSITIVE_INFINITY;
};

export const isMobileViewport = (
  viewport,
  breakpoint = MOBILE_VIEWPORT_BREAKPOINT
) => getViewportWidth(viewport) < breakpoint;
